import React, { useEffect } from "react";
import "./style.scss";
import { REGISTER_ADDRESS } from "../../../helperData/ApiAddress";
import { post } from "../../../controlers/global/ConfigRequest";
import { useTranslation } from "react-i18next";

export default function Register({ setMode, setActiveTab, setPhoneInit }) {
    const { t } = useTranslation();
    const [phone, setPhone] = React.useState("");
    const [phoneErr, setPhoneErr] = React.useState("");
    const [name, setName] = React.useState("");
    const [nameErr, setNameErr] = React.useState("");
    const [family, setFamily] = React.useState("");
    const [familyErr, setFamilyErr] = React.useState("");
    const [mail, setMail] = React.useState("");
    const [mailErr, setMailErr] = React.useState("");
    const [pass, setPass] = React.useState("");
    const [passErr, setPassErr] = React.useState("");
    const [pass2, setPass2] = React.useState("");
    const [pass2Err, setPass2Err] = React.useState("");

    const [loading, setLoading] = React.useState(false);
    const [resultErr, setResultErr] = React.useState("");

    useEffect(() => {
        console.log("dfsdfsdfsdf");
    }, []);

    const registerHandle = () => {
        let hasErr = false;
        let phoneStr;
        if (name.trim() === "") {
            setNameErr(t("Src.Component.Global.AuthModal.Register.setNameErr"));
            hasErr = true;
        }
        if (family.trim() === "") {
            setFamilyErr(
                t("Src.Component.Global.AuthModal.Register.setFamilyErr")
            );
            hasErr = true;
        }
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Register.setPhoneErr")
                );
                hasErr = true;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Register.setPhoneErr")
                );
                hasErr = true;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(
                t("Src.Component.Global.AuthModal.Register.setPhoneErr")
            );
            hasErr = true;
        }

        let patt = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

        if (!patt.test(mail)) {
            setMailErr(t("Src.Component.Global.AuthModal.Register.setMailErr"));
            hasErr = true;
        }

        if (pass.length < 8) {
            setPassErr(t("Src.Component.Global.AuthModal.Register.setPassErr"));
            hasErr = true;
        }
        if (pass !== pass2) {
            setPass2Err(
                t("Src.Component.Global.AuthModal.Register.setPass2Err")
            );
            hasErr = true;
        }
        if (hasErr === true) return false;
        setLoading(true);
        setResultErr("");
        post(REGISTER_ADDRESS, {
            phone_number: phoneStr,
            username: phoneStr,
            email: mail,
            first_name: name,
            last_name: family,
            password: pass,
        })
            .then((r) => {
                console.log("<><<<<<>>>>>201");
                setActiveTab(0);
                setMode(1);
                setPhoneInit(phoneStr);
                setLoading(false);
            })
            .catch((r) => {
                setLoading(false);
                if (r.response?.data.phone_number) {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.PhonesetResultErr"
                        )
                    );
                } else if (r.response?.data.non_field_errors) {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.EmailsetResultErr"
                        )
                    );
                } else if (r.response?.data.email) {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.EmailsetResultErr"
                        )
                    );
                } else {
                    setResultErr(
                        t(
                            "Src.Component.Global.AuthModal.Register.PhonesetResultErr"
                        ) || "Registration failed. Please try again."
                    );
                    console.log(r);
                }
            });
    };

    const nameHandle = (e) => {
        setName(e.target.value);
        setNameErr("");
    };

    const familyHandle = (e) => {
        setFamily(e.target.value);
        setFamilyErr("");
    };

    const phoneHandle = (e) => {
        let patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setPhoneErr("");
            setPhone(e.target.value);
        }
    };

    const mailHandle = (e) => {
        setMailErr("");
        setMail(e.target.value);
    };

    const passHandle = (e) => {
        setPass(e.target.value);
        setPassErr("");
    };

    const pass2Handle = (e) => {
        setPass2(e.target.value);
        setPass2Err("");
    };

    return (
        <>
            {/* <div className="auth-scroll-body"> */}
            <div className="register-container">
                <div className="input-form">
                    <div className="ri-input">
                        <label>{t("Name.Place.Holder")}</label>
                        <input
                            type="text"
                            placeholder={t("Name.Place.Holder")}
                            value={name}
                            onChange={nameHandle}
                            style={{ borderColor: nameErr && "orange" }}
                        />
                        {nameErr && (
                            <div className="login-form-err">{nameErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("LastName.Place.Holder")}</label>
                        <input
                            type="text"
                            placeholder={t("LastName.Place.Holder")}
                            value={family}
                            onChange={familyHandle}
                            style={{ borderColor: familyErr && "orange" }}
                        />
                        {familyErr && (
                            <div className="login-form-err">{familyErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("PhoneNumber.Place.Holder")}</label>
                        <input
                            type="tel"
                            placeholder={t("PhoneNumber.Hint.Place.Holder")}
                            value={phone}
                            onChange={phoneHandle}
                            style={{ borderColor: phoneErr && "orange" }}
                        />
                        {phoneErr && (
                            <div className="login-form-err">{phoneErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("EmailAddress.Place.Holder")}</label>
                        <input
                            type="email"
                            placeholder={t("EmailAddress.Hint.Place.Holder")}
                            value={mail}
                            onChange={mailHandle}
                            style={{ borderColor: mailErr && "orange" }}
                        />
                        {mailErr && (
                            <div className="login-form-err">{mailErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("Password.Place.Holder")}</label>
                        <input
                            type="password"
                            placeholder={t(
                                "Password.Hint.Register.Place.Holder"
                            )}
                            value={pass}
                            onChange={passHandle}
                            style={{ borderColor: passErr && "orange" }}
                        />
                        {passErr && (
                            <div className="login-form-err">{passErr}</div>
                        )}
                    </div>
                    <div className="ri-input">
                        <label>{t("RepeatPassword.Place.Holder")}</label>
                        <input
                            type="password"
                            placeholder={t("RepeatPassword.Hint.Place.Holder")}
                            value={pass2}
                            onChange={pass2Handle}
                            style={{ borderColor: pass2Err && "orange" }}
                        />
                        {pass2Err && (
                            <div className="login-form-err">{pass2Err}</div>
                        )}
                    </div>
                </div>
                <div className="ri-btn">
                    <button className="btn-st-1" onClick={registerHandle}>
                        {t("SignUp.Button")}
                    </button>
                    {/* <button onClick={handleClose} className="btn-st-2"><Google />ورود از طریق گوگل</button> */}
                    {loading && (
                        <div className="login-form-notif">
                            {t("Register.Loading")}
                        </div>
                    )}
                    {resultErr && (
                        <div className="login-form-err">{resultErr}</div>
                    )}
                </div>
            </div>
            {/* </div> */}
        </>
    );
}
